import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

// URL base de la API
// const API_URL = getApiBaseUrl();
const API_URL = getApiBaseUrl();



// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const postNotificación = async (datos) => {
  try {
    const response = await api.post('notificacion', datos);
    return response.data;

  } catch (error) {
    console.log("Error capturado en PostDatosPagos:", error); // Información adicional para depuración

    if (error.response) {
      // Error con respuesta del servidor
      const mensajeError = error.response.data?.message || "Error desconocido del servidor";
      throw new Error(`Error al enviar datos al backend: ${mensajeError}`);
    } else if (error.request) {
      // El cliente envió la solicitud pero no recibió una respuesta
      throw new Error("No se recibió respuesta del servidor. Por favor verifica tu conexión.");
    } else {
      // Otro tipo de error
      throw new Error(`Error inesperado: ${error.message}`);
    }
  }
};

export {  postNotificación };